import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'
import { headerStatStyles } from '../dynamic-widget/styled'

// Tarjeta de estadística con la cabecera común (título y línea en el color del cliente) y la
// tabla dentro con 16 px de padding, como las tablas de las estadísticas de talent
const TableStatisticStyled = styled.div`
  && {
    margin: 12px 0;
  }

  ${headerStatStyles}

  .table-wrapper {
    padding: 16px;
  }

  .MuiTableBody-root td {
    height: 48px;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 13px;
    font-weight: 400;
    color: ${tokens.color.text.secondary};

    span {
      font-weight: 400;
    }
  }
`

export default TableStatisticStyled
